// extracted by mini-css-extract-plugin
module.exports = {"block":"Info_block__2oZgr","ico":"Info_ico__h8rvZ"};